export default "__VITE_ASSET__BnwilcBa__"